import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { ClientOnly } from "@tanstack/react-router";

import { Like } from "./Like";

dayjs.extend(advancedFormat);
const CURRENT_YEAR = dayjs().format("YYYY");

export const TopRight = ({
  createdAt,
  like,
}: {
  createdAt: number;
  like: boolean;
}) => {
  const date = dayjs(createdAt * 1000);
  const dateUTC = date.format();

  let format = "dddd, MMMM Do";
  if (date.format("YYYY") < CURRENT_YEAR) format = "ddd, MMM Do YYYY";

  return (
    <div
      style={{
        display: "flex",
        fontSize: "13px",
        lineHeight: "28px",
        position: "absolute",
        right: 0,
        textAlign: "right",
        top: 0,
      }}
    >
      {like && (
        <Like to="/loved" title="See all Loved Coffees">
          <span role="img" aria-label="See all Loved Coffees">
            ❤️
          </span>
        </Like>
      )}

      <time
        style={{
          backgroundColor: "var(--yellow)",
          color: "#555",
          padding: "0 12px",
          height: "28px", // match line-height
        }}
        dateTime={dateUTC}
      >
        <ClientOnly fallback={dateUTC}>{date.format(format)}</ClientOnly>
      </time>
    </div>
  );
};
